module.exports = __webpack_public_path__ + "img/snowman_ico.c2dc280d.png";